import React, { Component } from 'react';
import BuscaAvancada, { BuscaAvancadaContext } from '../../../components/BuscaAvancada/buscaAvancada.component';
import Input from '../../../components/Input/input.component';
import SelectMulti from '../../../components/SelectMulti/selectmulti.component';
import { PRESTACAO_CONTAS_PERMISSIONS } from '../../../constants/index';
import CrepdecService from '../../../services/crepdecService';
import MunicipioService from '../../../services/municipioService';
import PrestacaoContasService from '../../../services/prestacaoContasService';
import { validatePermission } from '../../../utils/permissionHelper';

class PesquisaAvancadoPrestacaoContas extends Component {
	state = {
		municipios: [],
		crepdecs: [],
		status: [],
		localProcesso: [],
		forma: [],
		crepdecsFiltradas: [],
	}

	componentDidMount() {
		const { userInfo } = this.props;
		const userPermissions = userInfo.soeAcoes;

		if (validatePermission(PRESTACAO_CONTAS_PERMISSIONS.LISTAGEM_REGINONAL, userPermissions)) {
			MunicipioService.findAllByCrepdec(userInfo.codLocalidade).then((response) => {
				this.setState({
					municipios: response.data,
				});
			});
		} else {
			MunicipioService.findAll().then((response) => {
				this.setState({
					municipios: response.data,
				});
			});
		}

		CrepdecService.findAll().then((response) => {
			this.setState({
				crepdecs: response.data,
			});
		});

		PrestacaoContasService.findAllStatusPrestacaoContas().then((response) => {
			this.setState({
				status: response.data,
			});
		});

		PrestacaoContasService.findAllLocalProcesso().then((response) => {
			this.setState({
				localProcesso: response.data,
			});
		});

		PrestacaoContasService.findAllForma().then((response) => {
			this.setState({
				forma: response.data,
			});
		});
	}

	handleCrepdecByPermissiao = (crepdecs) => {
		const { userInfo } = this.props;
		const userPermissions = userInfo.soeAcoes;
		const codigo = userInfo.codLocalidade;

		const filterCrepdec = (codigoCrepdec, crepdecs) => {
			const crepdecsSelecionados = crepdecs.filter(item => item.id === codigoCrepdec).map(item => ({
				label: item.nomeExibicao,
				object: item,
				value: item.id,
			}));
			return crepdecsSelecionados;
		};

		if (validatePermission(PRESTACAO_CONTAS_PERMISSIONS.LISTAGEM_MUNICIPAL, userPermissions)) {
			const codigoIbge = codigo;
			const crepdecsMunicipal = this.state.municipios.filter(item => item.codigoIbge === codigoIbge).map(item => item.crepdec);
			if (crepdecsMunicipal.length > 0) {
				const [crepdec] = crepdecsMunicipal;
				const codigoCrepdec = crepdec.id;
				return filterCrepdec(codigoCrepdec, crepdecsMunicipal);
			}
		}
		if (validatePermission(PRESTACAO_CONTAS_PERMISSIONS.LISTAGEM_REGINONAL, userPermissions)) {
			const codigoCrepdec = codigo;
			return filterCrepdec(codigoCrepdec, crepdecs);
		}
		return [];
	}

	handleMunicipiosByPermissiao = (municipios) => {
		const { userInfo } = this.props;
		const userPermissions = userInfo.soeAcoes;
		const codigoIbge = userInfo.codLocalidade;

		if (validatePermission(PRESTACAO_CONTAS_PERMISSIONS.LISTAGEM_MUNICIPAL, userPermissions)) {
			const municipiosSelecionados = municipios.filter(item => item.codigoIbge === codigoIbge).map(item => ({
				label: item.nome,
				object: item,
				value: item.codigoIbge,
			}));
			return municipiosSelecionados;
		}
		return [];
	}

	handleDisabled = (fieldName) => {
		const { userInfo } = this.props;
		const userPermissions = userInfo.soeAcoes;

		if (fieldName === 'Município') {
			return validatePermission(PRESTACAO_CONTAS_PERMISSIONS.LISTAGEM_MUNICIPAL, userPermissions);
		}
		if (fieldName === 'CREPDEC') {
			return validatePermission([PRESTACAO_CONTAS_PERMISSIONS.LISTAGEM_REGINONAL, PRESTACAO_CONTAS_PERMISSIONS.LISTAGEM_MUNICIPAL], userPermissions);
		}
		return false;
	}

	render() {
		const {
			props: {
				filtro,
				handlePesquisaSimplificada,
				serviceSearch,
			},
			state: {
				municipios,
				crepdecs,
				status,
				localProcesso,
				forma,
			},
		} = this;

		return (
			<BuscaAvancada
				initialValues={filtro}
				handleSearch={(values) => {
					const filtroFinal = {};
					Object.assign(filtroFinal, values);
					filtroFinal.mumeroProcesso = values.mumeroProcesso !== ''
						? values.mumeroProcesso : null;

					filtroFinal.nomeOcorrencia = values.nomeOcorrencia !== ''
						? values.nomeOcorrencia : null;

					filtroFinal.idFormaList = values.formaList !== undefined
						&& values.formaList.length > 0
						? values.formaList.map(item => item.object.id) : null;

					filtroFinal.idStatusList = values.statusList !== undefined
						&& values.statusList.length > 0
						? values.statusList.map(item => item.object.id) : null;

					filtroFinal.idLocalProcessoList = values.localProcessoList !== undefined
						&& values.localProcessoList.length > 0
						? values.localProcessoList.map(item => item.object.id) : null;

					filtroFinal.codigoMunicipioList = values.municipiosList !== undefined
						&& values.municipiosList.length > 0
						? values.municipiosList.map(item => item.object.codigoIbge) : null;

					filtroFinal.idCrepdecList = values.crepdecList !== undefined
						&& values.crepdecList.length > 0
						? values.crepdecList.map(item => item.object.id) : null;

					serviceSearch(filtroFinal);
				}}
				handleClear={({ resetForm }) => {
					resetForm();
					serviceSearch(filtro);
				}}
				handlePesquisaSimplificada={handlePesquisaSimplificada}
			>
				<BuscaAvancadaContext.Consumer>
					{({
						values,
						handleChange,
						setFieldValue,
					}) => (
						<React.Fragment>
							<div className='row mt-3'>
								<div className='col-6'>
									<label>Processo</label>
									<Input
										type='input'
										name='mumeroProcesso'
										maxLength='255'
										onChange={handleChange}
										value={values.mumeroProcesso || ''}
									/>
								</div>

								<div className='col-6'>
									<label>Ocorrência</label>
									<Input
										type='input'
										name='nomeOcorrencia'
										maxLength='255'
										onChange={handleChange}
										value={values.nomeOcorrencia || ''}
									/>
								</div>
							</div>

							<div className='row'>
								<div className='col-6'>
									<label>Forma</label>
									<SelectMulti
										isMulti
										isClearable
										name='formaList'
										uniqueKey='id'
										label='nome'
										options={forma}
										value={values.formaList || []}
										onChange={(item) => {
											setFieldValue('formaList', item);
										}}
									/>
								</div>
								<div className='col-6'>
									<label>Status</label>
									<SelectMulti
										isMulti
										isClearable
										name='statusList'
										uniqueKey='id'
										label='nome'
										options={status}
										value={values.statusList || []}
										onChange={(item) => {
											setFieldValue('statusList', item);
										}}
									/>
								</div>
							</div>

							<div className='row  mt-2'>
								<div className='col-6'>
									<label>Local do processo</label>
									<SelectMulti
										isMulti
										isClearable
										name='localProcessoList'
										uniqueKey='id'
										label='nome'
										options={localProcesso}
										value={values.localProcessoList || []}
										onChange={(item) => {
											setFieldValue('localProcessoList', item);
										}}
									/>
								</div>
								<div className='col-6'>
									<label>Município</label>
									<SelectMulti
										isDisabled={this.handleDisabled('Município')}
										isMulti
										isClearable
										name='municipiosList'
										uniqueKey='codigoIbge'
										label='nome'
										options={municipios}
										value={values.municipiosList || this.handleMunicipiosByPermissiao(municipios)}
										onChange={(item) => {
											setFieldValue('municipiosList', item);
										}}
									/>
								</div>
							</div>

							<div className='row  mt-2'>
								<div className='col-6'>
									<label>CREPDEC</label>
									<SelectMulti
										isDisabled={this.handleDisabled('CREPDEC')}
										isMulti
										isClearable
										uniqueKey='id'
										name='crepdecList'
										label='nomeExibicao'
										options={crepdecs}
										value={values.crepdecList || this.handleCrepdecByPermissiao(crepdecs)}
										onChange={(item) => {
											setFieldValue('crepdecList', item);
										}}
									/>
								</div>
							</div>
						</React.Fragment>
					)}
				</BuscaAvancadaContext.Consumer>
			</BuscaAvancada>
		);
	}
}

export default PesquisaAvancadoPrestacaoContas;
